export const MF_SHORTY = "APV";
export const HOST_NAME_CONTROL = "control";
export const HOST_NAME_COCKPIT = "cockpit";
export const HOST_NAME_COCKPIT_ITALY = "cockpit-it";
export const REFRESH_IFRAME_TOKEN_EVENT_KEY = "refresh-iframe-token";
export const LOGOUT_IFRAME_EVENT_KEY = "logout-iframe";
